module.exports = __webpack_public_path__ + "static/media/ux-ui-designer.ae44e98e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/vacancies/ux-ui-designer.jpg
// module id = 357
// module chunks = 0